<ng-template #viewPopup>
    <div class="page-loading-shade" *ngIf="isProcessing">
        <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelViewPopup()" mat-button><i
            class="fa popupClose">&#xf00d;</i></button>
        <div mat-dialog-title>
            <label class="popupTitle" matTooltip="{{docViewer.docName}}">
            {{ displayName }}
            </label>
        <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div style="margin:10px 12px 0px 0px;"  *ngIf="message.isDocumentDownloader && !docViewer.isFromOnlyPreview">
        <div class="d-flex gap-2 action-buttons-container">
            <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                (click)="downloadDocument()" (keydown.enter)="downloadDocument()" matTooltip="Download file">
                <span class="reload_text text-white"><i class="fa fa-download"
                        aria-hidden="true"></i>&nbsp;&nbsp;Download</span>
            </div>

        </div>
    </div>
    <div style="margin: 15px 15px;" #webViewerContainer>
  <web-viewer #webViewerComp [data]="docViewer.doc" (oneQmsListener)="onUserActivity()"></web-viewer>
</div>
</ng-template>